import Image from 'next/image';

/**
 * Blurb image component using Next.js Image with responsive sizing.
 */
export default function BlurbImage({ src, alt = '', className = '', priority = false, ...props }) {
  return (
    <div className={`Blurb__image ${className}`}>
      {src && (
        <Image
          src={src}
          alt={alt}
          fill
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          priority={priority}
          {...props}
        />
      )}
    </div>
  );
}
